import Repository from '@/libs/axios'

const notificationResource = '/superadmin/tenants/notification'

export default {
  sendNotification(payload) {
    return Repository.post(`${notificationResource}`, payload)
  },
}
